import { useEffect, useState } from "react";
import ViewTable from "../../../components/tables/viewTable";
import dayjs from "dayjs";
import { eAdminTypes } from "../../../types/eAdminTypes";
type PropsType = {
  tableData: eAdminTypes[];
};
const RecentAdminTable = (props: PropsType) => {
  const { tableData } = props;
  const [modifiedTableData, setmodifiedTableData] = useState<any[]>([]);

  const columns = [
    { header: "Name", accessor: "nameIs" },
    { header: "Company Name", accessor: "companyName" },
    { header: "Email", accessor: "email" },
    { header: "Mobile Number", accessor: "mobileNumber" },
    { header: "Date", accessor: "invitedAt" },
  ];

  useEffect(() => {
    if (tableData?.length < 1) return;
    let _dataIs: any = [];
    for (let i = 0; i < tableData.length; i++) {
      const e: eAdminTypes = tableData[i];
      const countryCode = e?.user?.PhoneCountryCode || "+91";
      const mobileNumber = e?.user?.mobileNumber || "";
      const _admin = {
        userID: e?.user?.userID || "",
        nameIs: `${e?.employee?.firstName || ""} ${
          e?.employee?.lastName || ""
        }`,
        email: e?.user?.email || "",
        mobileNumber: `${countryCode} ${mobileNumber}`,
        invitedAt: !dayjs(e.employee.createdAt).isValid()
          ? "NA"
          : dayjs(e.employee.createdAt).format("MMM DD, YYYY"),
        companyName: e.company.CompanyName,
      };
      _dataIs.push(_admin);
    }
    setmodifiedTableData(_dataIs);
  }, [tableData]);
  return (
    <div>
      <ViewTable columns={columns} data={modifiedTableData} />
    </div>
  );
};

export default RecentAdminTable;
